export default __webpack_public_path__ + "static/media/gallery-18.e34227f4.jpg";